import { apiClient } from './api/client';
import { PromoCode, CreatePromoCodeDto, UpdatePromoCodeDto, ValidatePromoCodeDto, ValidatePromoCodeResult } from '@/types/promo-code.types';

export const promoCodeService = {
  async getAll(): Promise<PromoCode[]> {
    return await apiClient.get<PromoCode[]>('/promo-codes');
  },

  async getById(id: number): Promise<PromoCode> {
    return await apiClient.get<PromoCode>(`/promo-codes/${id}`);
  },

  async create(data: CreatePromoCodeDto): Promise<PromoCode> {
    return await apiClient.post<PromoCode>('/promo-codes', data);
  },

  async update(id: number, data: UpdatePromoCodeDto): Promise<PromoCode> {
    return await apiClient.put<PromoCode>(`/promo-codes/${id}`, data);
  },

  async delete(id: number): Promise<void> {
    return await apiClient.delete(`/promo-codes/${id}`);
  },

  async validate(data: ValidatePromoCodeDto): Promise<ValidatePromoCodeResult> {
    return await apiClient.post<ValidatePromoCodeResult>('/promo-codes/validate', data);
  },
};

